

























































































import { Component, Vue } from 'vue-property-decorator';
@Component({
})
export default class Citas extends Vue {

  private idPetco = this.$store.getters.user;
  private errores = false;
  private citasCliente: any = [];
  private visibleCitas = 'd-none';
  private visibleResult = 'd-none';
  /*SnackBar*/
  private snackbar = false;
  private text = '';
  private timeout = 2000;
  private card: any;
  private type = '';

  private cards: any = [];
  private dialog = false;

  private async goTiendas(){
    this.$store.dispatch('resetAll');
    this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/tiendas' : '/tiendas');
  }

  private created() {
    const promise = this.$store.dispatch('getCitasClienteFut', this.idPetco);
    promise.then((value) => {
      this.cards = value;
      this.errores = false;
      this.citasCliente = value;
      if (Object.keys(value).length === 0) {
          this.visibleCitas='';
          this.visibleResult='d-none';
      }
      else{
        this.visibleResult='';
        this.visibleCitas='d-none'
      }
    })
    .catch((error) => {
      this.errores = true;
    });
  }

  private editarCita(card:any) {
    // Seteamos en el store cada uno de los parámetros
    this.$store.commit('setMascotasCitas', [{NOMBRE: card.PET_NAME}]);
    this.$store.commit('setTiendaElegida', {TIENDA: card.TIENDA, TEXTO: card.TIENDA_TXT});
    this.$store.commit('setIdBloqueo', [card.ID_CITA]);
    this.$store.commit('setFechaCita', card.FECHA_INI);
    this.$store.commit('setHorarioElegido', {HORA_INI: card.HORA_INI, HORA_FIN: card.HORA_FIN});
    this.$router.push('/editarCita');
  }

  private cancelarDialog(card:any) {
    this.dialog = true;
    this.card = card;
  }
  private noCancelar(){
    this.dialog = false;
    this.card = null;
  }
    private cancelar() {
      this.dialog = false;
      const idCita = this.card.ID_CITA;
      let data = {
        idCliente: this.idPetco,
        idCita: [idCita]
      };
      this.$store.dispatch('cancelarCita', data)
      .then((val) => {
        if (val.replyCode === 200) {
          /*SnackBar*/
          this.snackbar = true;
          this.text = 'Cita cancelada';
          this.timeout = 3000;
          this.type = 'success';
          this.card = null;
          this.cards = [];
          setTimeout(() => {
            window.location.reload();
          }, 1000);
         
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }

    private formatHours(item: any) {
    let stringDT = '';
    stringDT += item.substring(0, 2) + ':' + item.substring(2, 4);
    return stringDT;
     }
  // Recibe una fecha en formato yyyymmdd y la convierte a dd/mm/yyyy
  private formatDate(fecha: any) {
    const anio = fecha.substring(0, 4);
    const mes = fecha.substring(4, 6);
    const dia = fecha.substring(6, 8);
    let mesString = '';
    if (mes === '01') {
      mesString = 'Enero';
    } else if (mes === '02') {
      mesString = 'Febrero';
    } else if (mes === '03') {
      mesString = 'Marzo';
    } else if (mes === '04') {
      mesString = 'Abril';
    } else if (mes === '05') {
      mesString = 'Mayo';
    } else if (mes === '06') {
      mesString = 'Junio';
    } else if (mes === '07') {
      mesString = 'Julio';
    } else if (mes === '08') {
      mesString = 'Agosto';
    } else if (mes === '09') {
      mesString = 'Septiembre';
    } else if (mes === '10') {
      mesString = 'Octubre';
    } else if (mes === '11') {
      mesString = 'Noviembre';
    } else if (mes === '12') {
      mesString = 'Diciembre';
     }
    return dia  + ' / ' + mesString  + ' / ' + anio;
  }
}
